"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleConnectError = exports.connectAppGenericFailure = exports.connectAppInvalidLicense = exports.connectAppAdminRequired = exports.connectAppCancelled = void 0;

var ActionTypes = _interopRequireWildcard(require("./ActionTypes"));

var _I18n = _interopRequireDefault(require("I18n"));

var I18N_PREFIX = 'appMarketplace.detail.header.connectAppButton.error';

var connectAppCancelled = function connectAppCancelled() {
  return {
    type: ActionTypes.APP_CONNECTION_CANCELLED,
    meta: {
      notification: {
        type: 'danger',
        titleText: _I18n.default.text(I18N_PREFIX + ".cancelled.titleText"),
        message: _I18n.default.text(I18N_PREFIX + ".cancelled.message")
      }
    }
  };
};

exports.connectAppCancelled = connectAppCancelled;

var connectAppAdminRequired = function connectAppAdminRequired(appName) {
  return {
    type: ActionTypes.APP_CONNECTION_ADMIN_REQUIRED,
    meta: {
      notification: {
        type: 'danger',
        titleText: _I18n.default.text(I18N_PREFIX + ".adminRequired.titleText"),
        message: _I18n.default.text(I18N_PREFIX + ".adminRequired.message", {
          appName: appName
        })
      }
    }
  };
};

exports.connectAppAdminRequired = connectAppAdminRequired;

var connectAppInvalidLicense = function connectAppInvalidLicense(appName) {
  return {
    type: ActionTypes.APP_CONNECTION_INVALID_LICENSE,
    meta: {
      notification: {
        type: 'danger',
        titleText: _I18n.default.text(I18N_PREFIX + ".invalidLicense.titleText"),
        message: _I18n.default.text(I18N_PREFIX + ".invalidLicense.message", {
          appName: appName
        })
      }
    }
  };
};

exports.connectAppInvalidLicense = connectAppInvalidLicense;

var connectAppGenericFailure = function connectAppGenericFailure() {
  return {
    type: ActionTypes.APP_CONNECTION_GENERIC_FAILED,
    meta: {
      notification: {
        type: 'danger',
        titleText: _I18n.default.text(I18N_PREFIX + ".default.titleText"),
        message: _I18n.default.text(I18N_PREFIX + ".default.message")
      }
    }
  };
};

exports.connectAppGenericFailure = connectAppGenericFailure;

var handleConnectError = function handleConnectError(errorType, appName) {
  return function (dispatch) {
    switch (errorType) {
      case 'CANCELLED':
        dispatch(connectAppCancelled());
        break;

      case 'INTEGRATION_ADMIN_REQUIRED':
        dispatch(connectAppAdminRequired(appName));
        break;

      case 'INTEGRATION_INVALID_LICENSE':
        dispatch(connectAppInvalidLicense(appName));
        break;

      default:
        dispatch(connectAppGenericFailure());
    }
  };
};

exports.handleConnectError = handleConnectError;


//////////////////
// WEBPACK FOOTER
// ./js/actions/ConnectActions.js
// module id = 797
// module chunks = 209 210 211 212